import fp from 'lodash/fp';

export const industriesSelector = state => state.industry.industries;

export const industryRolesSelector = state => state.industry.industryRoles;

export const defaultIndustryRoleSelector = state => fp.find(role => role.name === 'Not Specified')(state.industry.industryRoles)


// WEBPACK FOOTER //
// ./src/state/modules/industry/selectors.js